import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { createErrorNotification } from 'store/actions/notifications'
import { ShiftItem } from 'components/Items'
import { Card } from 'ui'
import { t } from 'translations'

const CoworkerModal = ({ rangeStart, rangeEnd }) => {
  const dispatch = useDispatch()
  const { uid: userId } = useSelector(state => state.auth.decodedToken)
  const [coworkerShifts, setCoWorkerShifts] = useState()
  useEffect(() => {
    const loadCoWorkerShifts = async () => {
      const { result, success } = await Api(`/schedule/coworkers`, { params: { employeeId: userId, rangeStart, rangeEnd } })
      if (!success) return dispatch(createErrorNotification())

      setCoWorkerShifts(result)
    }

    loadCoWorkerShifts()
  }, [dispatch, rangeEnd, rangeStart, userId])

  return (
    <BaseModal title="employee.mySchedule.CO_WORKERS_MODAL">
      <Card maxHeight="10rem" className="bg-light">
        {!coworkerShifts?.length ? (
          <div className="my-2 ml-2">
            <i className="far fa-empty-set"></i> {t('components.table.NOTHING_TO_DISPLAY')}
          </div>
        ) : (
          <ul className="mt-3">
            {coworkerShifts.map(shift => (
              <li key={shift._id}>
                <ShiftItem shift={shift} compact />
              </li>
            ))}
          </ul>
        )}
      </Card>
    </BaseModal>
  )
}

export default CoworkerModal
